import classNames from "classnames"

import type {
  ComponentPropsWithoutRef,
  FunctionComponentElement,
  Ref,
} from "react"

import {
  Children,
  forwardRef,
  useMemo,
} from "react"

import styles from "./FloatingActionButton.module.scss"
import { useCloneElement } from "src/hooks"

type ButtonAttributes = ComponentPropsWithoutRef<"button">

export interface Props extends ButtonAttributes {
  children?: FunctionComponentElement<SVGElement>;
}

export const FloatingActionButton = forwardRef<HTMLButtonElement, Props>(
  function FloatingActionButton(props: Props, propRef: Ref<HTMLButtonElement>) {
    const {
      children,
      ...htmlButtonProps
    } = props

    const child = Children.only<FunctionComponentElement<SVGElement>>(children || <svg />)

    const svgProps = useMemo(
      () => ({
        className: styles.floatingActionButtonIcon,
      }),
      [],
    )

    const clonedChild = useCloneElement<SVGElement>(
      child,
      svgProps,
    )

    const className = classNames(
      htmlButtonProps.className,
      styles.floatingActionButton,
    )

    return (
      <button
        type="button"
        {...htmlButtonProps}
        ref={propRef}
        className={className}
      >
        {clonedChild}
      </button>
    )
  },
)
